<template>
	<i ref="icon" class="icon" :class="[rotationClass, { flipX, flipY, spin }]">
		<slot></slot>
	</i>
</template>

<script>
export default {
	name: 'b-icon',
	props: {
		rotate: String,
		flipX: Boolean,
		flipY: Boolean,
		spin: Boolean
	},
	computed: {
		rotationClass() {
			if (!this.rotate) return '';
			return 'rotate-' + this.rotate;
		}
	},
	mounted() {
		this.$refs.icon.querySelector('svg').setAttribute('viewBox', '0 0 45 45');
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	font-size: inherit;
	vertical-align: middle;
	transform: translateY(-1px);
	transition: transform 0.3s;
	svg {
		width: 1em;
		height: auto;
		display: block;
	}
	*:not([fill='none']) {
		fill: currentColor;
	}
}
.rotate {
	&-1x {
		transform: rotate(90deg) translateY(-1px);
	}
	&-2x {
		transform: rotate(180deg) translateY(-1px);
	}
	&-3x {
		transform: rotate(-90deg) translateY(-1px);
	}
}
.flipX {
	transform: scaleX(-1) translateY(-1px);
}
.flipY {
	transform: scaleY(-1) translateY(-1px);
}
.spin {
	animation-name: spin;
	animation-duration: 1200ms;
	animation-iteration-count: infinite;
	animation-timing-function: linear;
}
@keyframes spin {
	from {
		transform: rotate(0deg) translateY(-1px);
	}
	to {
		transform: rotate(360deg) translateY(-1px);
	}
}
</style>

<docs>
  Ícones
</docs>
